<template>
  <avtalat-select
    id="kontaktorsak"
    v-model:value="kontaktorsakId"
    required
    label="Välj kontaktorsak"
    :disabled="disabled"
  >
    <option value="" disabled>Välj ett alternativ</option>
    <option
      v-for="(item, index) in kontaktorsakerOptions"
      :key="index"
      :value="item.id"
    >
      {{ item.label }}
    </option>
  </avtalat-select>
  <FormErrorMessage name="kontaktorsakId" />
  <avtalat-input
    id="fortydligad-kontaktorsak"
    v-if="kontaktorsakId === configStore.getKontaktorsakOvrigt?.id"
    v-model:value="fortydligadKontaktorsak"
    label="Förtydliga övrigt"
    required
    placeholder="Skriv en kontaktorsak"
  />
  <FormErrorMessage name="fortydligadKontaktorsak" />
  <MultiSelect
    label="Övriga samtalsämnen"
    placeholder="Välj ett eller flera alternativ"
    :options="samtalsamnenOptions"
    :selected="selectedSamtalsamneIds || []"
    @push="push"
    @remove="remove"
  />
  <FormErrorMessage name="samtalsamneIds" />
</template>

<script setup lang="ts">
import { computed } from "vue";

import FormErrorMessage from "@/components/ui/FormErrorMessage.vue";
import { useConfigStore } from "@/stores";
import { kontaktorsakerToOptions } from "@/common/mappers";

import MultiSelect from "../ui/MultiSelect.vue";

const configStore = useConfigStore();

defineProps<{
  disabled?: boolean | null | undefined;
  selectedSamtalsamneIds: string[];
}>();

const kontaktorsakId = defineModel<string>("kontaktorsakId");
const fortydligadKontaktorsak = defineModel<string>("fortydligadKontaktorsak");

const emit = defineEmits(["push", "remove"]);

const push = (value: string) => emit("push", value);
const remove = (idx: number) => emit("remove", idx);

const kontaktorsakerOptions = computed(() =>
  kontaktorsakerToOptions(configStore.kontaktorsaker),
);

const samtalsamnenOptions = computed(() =>
  kontaktorsakerToOptions(configStore.ovrigaSamtalsamnen),
);
</script>
